
// REF: https://zeroheight.com/60d194782/p/09a0a6-colours/b/631b3d
//
// Higher number means darker color
//
// The tints are between 100 to 400.
// The main colour is 500.
// The shades are between 600 to 900.

export const Colors = {
	white: {
		background: {
			hex: '#FFFFFF',
			rgb: 'rgb(255, 255, 255)',
		},
	},
	blue: {
		main: {
			b500:{
				hex: '#0075DB',
				rgb: 'rgb(0, 117, 219)',
			},
		},
		tints: {
			b100: {
				hex: '#EAF5FF',
				rgb: 'rgb(234, 245, 255)',
			},
			b200: {
				hex: '#BFE0FF',
				rgb: 'rgb(191, 224, 255)',
			},
		},
		shades: {
			b700: {
				hex: '#003B6E',
				rgb: 'rgb(0, 59, 110)',
			},
			b900: {
				hex: '#001F3D',
				rgb: 'rgb(0, 31, 61)',
			},
		},
	},
	green: {
		main: {
			g500:{
				hex: '#32872C',
				rgb: 'rgb(50, 135, 44)',
			},
		},
		tints: {
			g200: {
				hex: '#CCEEC9',
				rgb: 'rgb(204, 238, 201)',
			},
		},
		shades: {
			g900: {
				hex: '#1C4D19',
				rgb: 'rgb(204, 238, 201)',
			},
		},
	},
	yellow: {
		main: {
			y500:{
				hex: '#FFF13A',
				rgb: 'rgb(255, 241, 58)',
			},
		},
		tints: {
			y200: {
				hex: '#FFFFB8',
				rgb: 'rgb(255, 255, 184)',
			},
		},
		shades: {
			y900: {
				hex: '#5E5E00',
				rgb: 'rgb(94, 94, 0)',
			},
		},
	},
	orange: {
		main: {
			o500:{
				hex: '#F58F18',
				rgb: 'rgb(245, 143, 24)',
			},
		},
		tints: {
			o200: {
				hex: '#FCD7AD',
				rgb: 'rgb(252, 215, 173)',
			},
		},
		shades: {
			o900: {
				hex: '#5D3304',
				rgb: 'rgb(93, 51, 4)',
			},
		},
	},
	red: {
		main: {
			r500:{
				hex: '#B4110F',
				rgb: 'rgb(180, 17, 15)',
			},
		},
		tints: {
			r200: {
				hex: '#FAC1C0',
				rgb: 'rgb(250, 193, 192)',
			},
			r300: {
				hex: '#E71613',
				rgb: 'rgb(231, 22, 19)',
			},
		},
		shades: {
			r900: {
				hex: '#730B09',
				rgb: 'rgb(115, 11, 9)',
			},
		},
	},
	purple: {
		main: {
			pu200:{
				hex: '#DFE4F0',
				rgb: 'rgb(223, 228, 240)',
			},
		},
	},
	neutrals: {
		main: {
			gy500:{
				hex: '#5C5C5C',
				rgb: 'rgb(92, 92, 92)',
			},
		},
		tints: {
			gy100: {
				hex: '#F3F3F3',
				rgb: 'rgb(243, 243, 243)',
			},
			gy200: {
				hex: '#DCDCDC',
				rgb: 'rgb(220, 220, 220)',
			},
			gy400: {
				hex: '#68778D',
				rgb: 'rgb(104, 119, 141)',
			},
		},
		shades: {
			gy900: {
				hex: '#3B3B3B',
				rgb: 'rgb(59, 59, 59)',
			},
		},
	},
	// These are not part of zeroheight (ref url at top) default colors scheme; Karim is using it for app delivery color
	extras: {
		green: {
			t500: {
				hex: '#197E84',
				rgb: 'rgb(25, 126, 132)',
			},
		},
	},
}

export const ColorStatusGroupHEX = {
	main: {
		primary: Colors.blue.main.b500.hex,
		secondary: Colors.blue.tints.b100.hex,
	},
	success: {
		primary: Colors.green.main.g500.hex,
		secondary: Colors.green.tints.g200.hex,
	},
	warn: {
		primary: Colors.orange.shades.o900.hex,
		secondary: Colors.orange.tints.o200.hex,
	},
	alert: {
		primary: Colors.red.main.r500.hex,
		secondary: Colors.red.tints.r200.hex,
	},
	notification: {
		primary: Colors.yellow.main.y500.hex,
		secondary: Colors.yellow.tints.y200.hex,
	},
}

export const ColorBackgroundHEX = {
	white: {
		primary: Colors.white.background.hex,
	},
	blue: {
		primary: Colors.blue.main.b500.hex,
		secondary: Colors.blue.tints.b200.hex,
	},
	gray: {
		primary: Colors.neutrals.tints.gy200.hex,
		secondary: Colors.neutrals.tints.gy100.hex,
	},
	red: {
		primary: Colors.red.main.r500.hex,
		secondary: Colors.red.tints.r200.hex,
	},
}